import React from 'react';
import { formatUsd } from '../../data/countries';
import { formatInvestTaxLabel } from '../investment/InvestModal';
import CostDonutChart from './CostDonutChart';

export const buildSaleInvestmentDonutSegments = (estimate) => {
  const taxLabel = formatInvestTaxLabel(estimate.vatLabel, estimate.vatRate);
  const segments = [
    { value: estimate.subtotalUsd, color: "var(--primary)", label: "Share subtotal", swatchClass: "rent-cost-donut-swatch--rent" },
    { value: estimate.acquisitionFeeUsd, color: "#2a9d8f", label: "Acquisition fee (5%)", swatchClass: "rent-cost-donut-swatch--extra" },
  ];
  if (estimate.vatAmountUsd > 0) {
    segments.push({ value: estimate.vatAmountUsd, color: "var(--accent)", label: taxLabel, swatchClass: "rent-cost-donut-swatch--tax" });
  }
  return segments;
};

const SaleInvestmentCostBreakdown = ({ estimate, country, compact = false, title, caption }) => {
  if (!estimate?.totalUsd || estimate.totalUsd <= 0) return null;
  const segments = buildSaleInvestmentDonutSegments(estimate);
  return (
    <div className={`sale-invest-cost-breakdown rent-monthly-costs-breakdown${compact ? " rent-monthly-costs-breakdown--compact" : ""}`}>
      <h4 style={{ margin: compact ? "0 0 0.65rem" : "0 0 0.75rem", fontSize: compact ? "0.95rem" : "1.05rem" }}>
        {title || "Investment cost at a glance"}
      </h4>
      <CostDonutChart
        segments={segments}
        total={estimate.totalUsd}
        country={country}
        compact={compact}
        centerHint="Total (incl. fees)"
        ariaLabel="Investment subtotal, fees, and tax"
        formatValue={(n) => formatUsd(n)}
      />
      {caption ? (
        <p style={{ fontSize: "0.78rem", color: "var(--text-light)", margin: "0.65rem 0 0", lineHeight: 1.5 }}>{caption}</p>
      ) : null}
    </div>
  );
};

export default SaleInvestmentCostBreakdown;
